<script>
import { Select } from 'ant-design-vue';

export default {
  emits: [
    'onChange',
    'deselect',
    'select',
    'onPopupScroll',
    'onSearch',
    'onDropdownVisibleChange',
  ],
  components: { SelectComp: Select },
  props: {
    options: {
      type: Array,
      default: null,
    },
    value: {
      type: [Array, String],
      default: '',
    },
    mode: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    customStyle: {
      type: Object,
      default: () => ({ width: '20.75rem' }),
    },
    showSearch: {
      type: Boolean,
      default: false,
    },
    placement: {
      type: String,
      default: 'bottomLeft',
    },
    size: {
      type: String,
      default: 'default',
    },
    filterOption: {
      type: [Boolean, Function],
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxTagTextLength: {
      type: Number,
      default: null,
    },
    maxTagCount: {
      type: Number,
      default: null,
    },
    getPopupContainer: {
      type: Function,
      default: (triggerNode) => triggerNode.parentNode,
    },
    fieldNames: {
      type: Object,
      default: () => undefined,
    },
  },
  computed: {
    getStyleObj() {
      return { textAlign: 'left', ...this.customStyle };
    },
  },
};
</script>

<template>
  <div>
    <SelectComp
      @change="(value, option) => $emit('onChange', value, option)"
      @select="(value, option) => $emit('select', value, option)"
      @deselect="(value, option) => $emit('deselect', value, option)"
      :value="value"
      :mode="mode"
      class="rex-select-comp"
      :placeholder="placeholder"
      :style="getStyleObj"
      :dropdownStyle="{ textAlign: 'left' }"
      :options="options"
      :showArrow="true"
      :showSearch="showSearch"
      :placement="placement"
      :size="size"
      @popupScroll="(...rest) => $emit('onPopupScroll', ...rest)"
      @search="(...rest) => $emit('onSearch', ...rest)"
      @dropdownVisibleChange="(open) => $emit('onDropdownVisibleChange', open)"
      :filterOption="filterOption"
      :maxTagTextLength="maxTagTextLength"
      :maxTagCount="maxTagCount"
      :disabled="disabled"
      :getPopupContainer="getPopupContainer"
      :fieldNames="fieldNames"
    >
      <template #default>
        <slot></slot>
      </template>
    </SelectComp>
  </div>
</template>

<style lang="scss" scoped></style>
